import {
  FeedCreditLog,
  TeamFeedBalance,
} from '@cbinsights/datafeedcreditservice/datafeedcreditservice';
import {
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from 'react-query';
import { ResponseError } from 'superagent';
import { request } from 'client/modules/common/utils/request';

export const useGetTeamFeedBalance = (
  idTeam: number
): UseQueryResult<TeamFeedBalance, ResponseError> =>
  useQuery(
    ['datafeedcreditservice/TeamFeedBalance', idTeam],
    () =>
      request({
        url: '/service/datafeedcreditservice/ListTeamFeedBalances',
        body: { parent: idTeam.toString() },
      }).then((res): TeamFeedBalance => res.body.team_feed_balances[0]),
    { enabled: idTeam > 0 }
  );

export const useCreateTeamFeedBalance = (): UseMutationResult<
  TeamFeedBalance,
  ResponseError
> => {
  const queryClient = useQueryClient();
  return useMutation(
    (idTeam: number) =>
      request({
        url: '/service/datafeedcreditservice/BatchCreateTeamFeedBalances',
        body: {
          requests: [
            {
              team_feed_balance: {
                id_team: idTeam.toString(),
                current_balance: 0,
              },
            },
          ],
        },
      }).then((res): TeamFeedBalance => res.body.team_feed_balances[0]),
    {
      onSuccess: (data) => {
        const idTeam = Number(data.id_team);
        queryClient.invalidateQueries([
          'datafeedcreditservice/TeamFeedBalance',
          idTeam,
        ]);
      },
    }
  );
};

const FEED_CREDIT_LOG_TYPE_ADD_CREDITS = 1;

export const useAddFeedCredits = (): UseMutationResult<
  FeedCreditLog,
  ResponseError
> => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ idTeam, amount }: { idTeam: number; amount: number }) =>
      request({
        url: '/service/datafeedcreditservice/BatchCreateFeedCreditLogs',
        body: {
          requests: [
            {
              feed_credit_log: {
                id_team: idTeam,
                credit_delta: amount,
                feed_credit_log_type: FEED_CREDIT_LOG_TYPE_ADD_CREDITS,
              },
            },
          ],
        },
      }).then((res): FeedCreditLog => res.body.feed_credit_logs[0]),
    {
      onSuccess: (data) => {
        const idTeam = Number(data.id_team);
        queryClient.invalidateQueries([
          'datafeedcreditservice/TeamFeedBalance',
          idTeam,
        ]);
      },
    }
  );
};
